import { Component } from '@angular/core';

@Component({
    standalone: false,
    selector: 'cva-expansion-panel',
    templateUrl: './expansion-panel.component.html',
    
})
export class ExpansionPanelComponent {
  panelOpenState = false;
}
